import { observer } from 'mobx-react'
import React, { Component } from 'react'

import ResponseRateStore from './ResponseRateStore'
import Date from '../../../form/Date'
import DataTable from '../../../DataTable'
import Button from '../../../../UniformComponents/Button'
import Panel from '../../../../UniformComponents/Panel'
import Typography from '../../../../UniformComponents/Typography'
import Select from '../../../form/Select'
import Loader from '../Loader'

import './systemResponseRate.scss'

@observer
class SystemResponseRate extends Component {
    constructor(props) {
        super(props)
        const { store } = props
        this.responseRateStore = new ResponseRateStore(store)
    }

    componentDidMount() {
        const { store } = this.props
        this.responseRateStore.getOptions()
        store.breadcrumps = [
            {
                name: 'intranet',
                url: '/intranet',
                title: 'Intranet',
            },
            {
                name: 'systemResponseRates',
                url: '/intranet/systemResponseRates',
                title: 'System Response Rates',
            },
        ]
    }

    renderFilters = () => {
        const {
            surveyTypes,
            respondentTypes,
            responseRateRequest,
            handleChangeRequest,
            getSystemResposeRate,
        } = this.responseRateStore
        const {
            startDate, endDate, surveyType, respondentType,
        } = responseRateRequest
        return (
            <Panel className="filterPanel">
                <Typography type="h2">System Response Rates</Typography>

                <Select
                    label="Survey Type"
                    options={surveyTypes}
                    onChange={(e) => handleChangeRequest(e.value, 'surveyType')}
                    value={surveyTypes
                        .find((option) => option.value === surveyType)}
                />

                <Select
                    label="Respondent Types:"
                    options={respondentTypes}
                    onChange={(e) => handleChangeRequest(e, 'respondentType')}
                    isMulti
                    closeMenuOnSelect={false}
                    value={respondentType.length > 0
                        ? respondentTypes.find(
                            (option) => option.value === respondentType,
                        )
                        : null}
                    defaultValue={respondentTypes}
                />

                <div style={{ display: 'flex' }}>
                    <Date
                        label="Start Date"
                        onBlur={(value) => handleChangeRequest(value, 'startDate')}
                        placeholder={startDate || 'YYYY-MM-DD'}
                        dateFormat="YYYY-MM-DD"
                        allowManualDateEdit
                    />
                </div>
                <div style={{ display: 'flex' }}>
                    <Date
                        label="End Date"
                        onBlur={(value) => handleChangeRequest(value, 'endDate')}
                        placeholder={endDate || 'YYYY-MM-DD'}
                        dateFormat="YYYY-MM-DD"
                        allowManualDateEdit
                    />
                </div>

                <Button
                    cssClass="regular primary"
                    onClick={getSystemResposeRate}
                    label="GO"
                />
            </Panel>
        )
    }

    renderResultReport = () => {
        const { response } = this.responseRateStore
        return (
            <Panel style={{ overflow: 'auto' }}>
                <div style={{ display: 'flex' }} id="result">
                    <h2>Report Statistics</h2>
                    <p>
                        {response.closedSurveys}
                        {' '}
                        surveys which closed in this time period
                    </p>
                    <p>
                        {response.completions}
                        {' '}
                        completed responses via email

                    </p>
                    <p>
                        {response.uniqueEmails}
                        {' '}
                        unique emails contacted

                    </p>
                    <p>
                        {(response.responseRate * 100).toFixed(2)}
                        {' '}
                        % response rate

                    </p>
                </div>

                {response.surveys.length > 0 ? this.renderTable() : null}

            </Panel>
        )
    }

    renderTable = () => {
        const { response, columns } = this.responseRateStore
        return (
            <div>
                <h2>Surveys of this report are:</h2>
                <DataTable
                    store={{ filteredList: response.surveys }}
                    dataSet={response.surveys}
                    columns={columns}
                    inMemory
                />
            </div>
        )
    }

    render() {
        const { isResultFetchedOnce, pending } = this.responseRateStore
        return (

            <div id="systemResponseRate">
                <Loader show={pending} />
                {!isResultFetchedOnce
                    ? (
                        <div>
                            <div className="colInitial">{this.renderFilters()}</div>
                        </div>
                    )
                    : (
                        <div>
                            <div>

                                {this.renderFilters()}

                            </div>
                            <div>

                                {this.renderResultReport()}

                            </div>
                        </div>
                    )}
            </div>

        )
    }
}
export default SystemResponseRate
